import Overlay from './map/overlay'
import OverlayShape from './map/overlay_shape'
import OverlayMapType from './map/overlay_map_type'
import mapConverters from './map/map_converters'

class GlobalOverlayManager {
  constructor() {
    if (!GlobalOverlayManager.instance) {
      GlobalOverlayManager.instance = this;
      this.NOSY_NEIGHBOR_ZOOM_LEVEL = 19;
      this.data = {
        googleMap: null,
        // An object where the overlays will be referenced by the key name
        overlays: {},
        // An array of keys that reference the overlays object
        selectedMyMapOverlays: [],
        // An array of objects with mls overlay id and layer name
        selectedMlsOverlays: [],
        // Google shapes
        overlaysOnTheMap: {},
        filteredOverlaysOnTheMap: {},
        filteredOverlayShapesOnTheMap: {}
      }
    }
    return GlobalOverlayManager.instance;
  }

  /* --------------------
    MLS Overlays
  -------------------- */
  addMlsOverlay(overlayId, overlayName) {
    const existingOverlay = this.data.selectedMlsOverlays.some(obj => obj.Id === overlayId);

    if (!existingOverlay) {
      this.data.selectedMlsOverlays.push({ Id: overlayId, LayerName: overlayName });
      this.data.googleMap.overlayMapTypes.push(new OverlayMapType(overlayName));
    }
  }

  removeMlsOverlay(overlayId) {
    const index = this.data.selectedMlsOverlays.findIndex(obj => obj.Id === overlayId);

    if (index !== -1) {
      this.data.selectedMlsOverlays.splice(index, 1);
      this.data.googleMap.overlayMapTypes.removeAt(index);
    }
  }

  getSelectedMlsOverlays() {
    return this.data.selectedMlsOverlays;
  }

  loadSelectedMlsOverlays() {
    // This should only be done when initializing the map.
    let self = this
    this.data.selectedMlsOverlays.forEach(overlay => {
      self.data.googleMap.overlayMapTypes.push(new OverlayMapType(overlay.LayerName));
    })
  }


  /* --------------------
    My Map Overlays
  -------------------- */
  createNewMyMapOverlay(ajaxPayload) {
    let self = this;
    $.ajax({
      url: '/search/overlays/edit_overlay',
      method: 'POST',
      data: ajaxPayload,
      success: function(responseData) {
        if (responseData.success) {
          let overlay = new Overlay(responseData, true);
          self.data.overlays[overlay.Id] = overlay

          window.dispatchEvent(new CustomEvent("map:newOverlayCreated", {
            detail: {
              overlay: overlay
            }
          }));
        } else {
          toast.error(responseData.message)
        }
      },
      error: function(jqXHR, textStatus, errorThrown) {
        toast.error("Error creating the overaly: ", errorThrown);
      }
    })
  }

  updateExistingMyMapOverlay(ajaxPayload) {
    let self = this;
    $.ajax({
      url: '/search/overlays/edit_overlay',
      method: 'POST',
      data: ajaxPayload,
      success: function(responseData) {
        if (responseData.success) {
          let overlay = new Overlay(responseData, true);
          // Update the overlay in our cache
          self.data.overlays[overlay.Id] = overlay

          window.dispatchEvent(new CustomEvent("map:overlayUpdated", {
            detail: {
              overlay: overlay
            }
          }));
        } else {
          toast.error(responseData.message)
        }
      },
      error: function(jqXHR, textStatus, errorThrown) {
        toast.error("Error updating the overlay: ", errorThrown);
      }
    })
  }

  async getMyMapOverlay(overlayId) {
    // Given an ID, retrieve the overlay from the global manager's
    // storage or from the server.
    if (this.hasOverlay(overlayId)) {
      // We already retrieved this information.  Return it
      return this.data.overlays[overlayId];
    } else {
      // Go get the information we desire
      try {
        const request = new Request(window.routes.overlay_path(overlayId), { method: 'GET' });
        const response = await fetch(request);
        const json = await response.json();
        if (json.success) {
          this.data.overlays[overlayId] = new Overlay(JSON.parse(json.data).attributes);
          return this.data.overlays[overlayId];
        } else {
          return null;
        }
      } catch (error) {
        console.error('Error fetching overlay:', error);
        return null;
      }
    }
  }

  addMyMapOverlay(overlay) {
    // Add an overlay to storage (if it does not already exist)
    if (!this.hasOverlay(overlay.Id)) {
      this.data.overlays[overlay.Id] = overlay;
    }
  }

  addMyMapOverlayToMap(overlay, opts = {}) {
    // Add the overlay to the map
    // But first, make sure it is in our list overlays
    this.addMyMapOverlay(overlay)

    if (!this.data.selectedMyMapOverlays.includes(overlay.Id)) {
      this.data.selectedMyMapOverlays.push(overlay.Id);

      var self = this;
      overlay.Shapes.forEach(function(overlayShape) {
        self._addShapeToMap(overlayShape, opts.color)
      });
    }
  }

  removeMyMapOverlayFromMap(overlayId, color) {
    // Remove the overlay id from the 'selected' array
    this.data.selectedMyMapOverlays = this.data.selectedMyMapOverlays.filter(item => item !== overlayId)

    let key = this._storageKey(overlayId, color);

    // Remove the map entities
    this.data.overlaysOnTheMap[key].forEach(function(googleShape) {
      googleShape.setMap(null)
    });
    delete this.data.overlaysOnTheMap[key];
  }

  addFilterOverlayShapeToMap(key, shape) {
    let options = {}
    let useOverlayArray = key !== shape.Id
    let workingObject = useOverlayArray ? this.data.filteredOverlaysOnTheMap : this.data.filteredOverlayShapesOnTheMap
    let keyExists = (key in workingObject)

    // If it is an overlay key, we dont care if it exists.  We want to add multiple shapes here.
    // If not an overlay key, then check to see if the shape key exists and skip the work if it does.
    if (useOverlayArray || !keyExists) {

      options = {
        strokeColor: '#' + shape.Color,
        fillColor: '#' + shape.Color,
        fillOpacity: 0.25,
        zIndex: 10 // Higher index for filtered overlay shapes vs unfiltered overlay shapes
      };

      let googleShape = this._buildGoogleShape(shape, options);
      googleShape.setMap(this.data.googleMap);

      // Check the current zoom level and set visibility accordingly
      const currentZoom = this.data.googleMap.getZoom();
      if (currentZoom >= this.NOSY_NEIGHBOR_ZOOM_LEVEL) {
        googleShape.setVisible(false);
      }

      if (!keyExists) {
        workingObject[key] = []
      }
      workingObject[key].push(googleShape)
    }
  }

  removeFilterOverlayShapeFromMap(shapeId) {
    if (shapeId in this.data.filteredOverlayShapesOnTheMap) {
      // Remove the map entities
      this.data.filteredOverlayShapesOnTheMap[shapeId].forEach(function(googleShape) {
        googleShape.setMap(null)
      });
      delete this.data.filteredOverlayShapesOnTheMap[shapeId];
    }
  }

  clearAllFilteredShapes() {
    let self = this
    Object.keys(this.data.filteredOverlaysOnTheMap).forEach(overlayId => {
      self.data.filteredOverlaysOnTheMap[overlayId].forEach(function(googleShape) {
        googleShape.setMap(null)
      });
      delete self.data.filteredOverlaysOnTheMap[overlayId];
    });

    Object.keys(this.data.filteredOverlayShapesOnTheMap).forEach(shapeId => {
      self.data.filteredOverlayShapesOnTheMap[shapeId].forEach(function(googleShape) {
        googleShape.setMap(null)
      });
      delete self.data.filteredOverlayShapesOnTheMap[shapeId];
    });
  }

  _addShapeToMap(overlayShape, color) {
    let options = {};

    if(typeof color !== 'boolean'){
      color = true;
    }

    if(!color){
      options = {
        strokeColor: '#FFFFFF',
        fillColor: '#000000',
        fillOpacity: 0.15
      };
    }

    let googleShape = this._buildGoogleShape(overlayShape, options);
    if (!googleShape.get('zIndex')) {
      // If no priority, low priority
      googleShape.set('zIndex', 1);
    }

    googleShape.setMap(this.data.googleMap);

    // Check the current zoom level and set visibility accordingly
    // Only if the map is fully initialized (getZoom returns a valid number)
    const currentZoom = this.data.googleMap.getZoom();
    if (typeof currentZoom === 'number' && currentZoom >= this.NOSY_NEIGHBOR_ZOOM_LEVEL) {
      googleShape.setVisible(false);
    }

    let key = this._storageKey(overlayShape.OverlayId, color);

    if(typeof this.data.overlaysOnTheMap[key] === 'undefined' ){
      this.data.overlaysOnTheMap[key] = [];
    }

    this.data.overlaysOnTheMap[key].push(googleShape);
  }

  addShapeToFilter(shape) {
    toast.warning("Need to implement Add To Filter functionality")
  }

  removeShapeFromFilter(shape) {
    toast.warning("Need to implement Remove From Filter functionality")
  }


  loadSelectedMyMapOverlays() {
    // This should only be done when initializing the map.

    // First lets clear out anything that we THINK is on the map
    this.data.overlaysOnTheMap = {};

    for (let x = 0; x < this.data.selectedMyMapOverlays.length; x++) {
      let overlay = this.data.overlays[this.data.selectedMyMapOverlays[x]]
      for (let y = 0; y < overlay.Shapes.length; y++) {
        this._addShapeToMap(overlay.Shapes[y], false)
      }
    }

    // After loading all shapes, ensure visibility is correct based on current zoom level
    const currentZoom = this.data.googleMap.getZoom();
    if (typeof currentZoom === 'number' && currentZoom >= this.NOSY_NEIGHBOR_ZOOM_LEVEL) {
      this.toggleUnfilteredOverlayShapesVisibility(false);
    }
  }


  /* --------------------
    My Map Overlay Shapes
  -------------------- */

  async getMyMapOverlayShape(shapeId) {
    // We have a shape ID. Look for it in our stored overlays
    for(let key in this.data.overlays) {
      const shape = this.data.overlays[key].Shapes.find(shape => shape.Id === shapeId.replace(/^'|'$/g, ''));
      if (shape) {
        return shape;
      }
    }
    // We didnt find anything loaded in our overlay memory.  Go get the individual shape information
    let shapes = await OverlayShape.find("'" + shapeId + "'")
    if (shapes.length >= 1) {
      const shape = shapes[0];
      // If the shape has an OverlayId and we don't have that overlay loaded yet,
      // retrieve the parent overlay in the background
      if (shape.OverlayId && !this.hasOverlay(shape.OverlayId)) {
        // Retrieve the parent overlay in the background (don't await to avoid blocking)
        this.getMyMapOverlay(shape.OverlayId).catch(error => {
          console.error('Error fetching parent overlay in background:', error);
        });
      }

      return shape;
    }
    return null;
  }

  async getMyMapOverlayShapeFromOverlay(shapeId, overlayId) {
    // Look for a shape by its ID/overlay ID.  If we don't
    // already have it stored, load it.
    if (this.hasOverlay(overlayId)) {
      const shape1 = this.data.overlays[overlayId].Shapes.find(shape => shape.Id === shapeId.replace(/^'|'$/g, ''));
      return shape1;
    } else {
      const overlay = await this.getMyMapOverlay(overlayId);
      if (overlay) {
        const shape2 = this.data.overlays[overlayId].Shapes.find(shape => shape.Id === shapeId.replace(/^'|'$/g, ''));
        return shape2;
      }
    }
    // Couldn't find the shape.
    return null;
  }

  fillOverlayShape(shapeId, fillValue) {
    if (shapeId in this.data.filteredOverlayShapesOnTheMap) {
      this.data.filteredOverlayShapesOnTheMap[shapeId].forEach(function(googleShape) {
        googleShape.set('fillOpacity',fillValue);
      });
    }
  }


  /* --------------------
    The google map
  -------------------- */

  setMap(value) {
    this.data.googleMap = value
  }

  getMap() {
    return this.data.googleMap
  }

  _buildGoogleShape(overlayShape, options) {
    if(typeof options === 'undefined') {
      options = {};
    }

    let points = mapConverters.sparkBoundaryToPoints(overlayShape.Geometry);
    let color = '#' + overlayShape.Color;
    let defaults = {
      path: points,
      strokeColor: color,
      strokeWeight: 1,
      fillColor: color,
      fillOpacity: 0.15,
      clickable: false,
      zIndex: 1   // All other shapes should appear on top of this one
    };
    let args = $.extend({}, defaults, options);

    // We need the shape to have a shapeName for display purposes and the Id for easy lookup
    let newShape = new google.maps.Polygon(args);
    newShape.set('shapeName', overlayShape.Name);
    newShape.set('overlayShapeId', overlayShape.Id);
    return newShape;
  }

  _storageKey(overlayId, color) {
    return (color) ? overlayId : overlayId + "Grayscale";
  }

  hasOverlay(overlayId) {
    return (Object.keys(this.data.overlays).includes(overlayId))
  }

  getTotalMapOverlayShapeBounds(additionalShapeToInclude = null) {
    let bounds = null;
    let self = this;
    Object.keys(this.data.filteredOverlayShapesOnTheMap).forEach(shapeId => {
      self.data.filteredOverlayShapesOnTheMap[shapeId].forEach(function(googleShape) {
        let pointsArray = googleShape.getPath();
        if (bounds === null) {
          bounds = mapConverters.getGoogleBoundsFromPoints(pointsArray)
        } else {
          bounds.union(mapConverters.getGoogleBoundsFromPoints(pointsArray))
        }
      });
    });

    // This shape hasnt made it to the filtered overlays shapes array yet.  But we still want
    // to include it in the bounds calculation.
    if (additionalShapeToInclude !== null) {
      let pointsArray = additionalShapeToInclude.getPath();
      if (bounds === null) {
        bounds = mapConverters.getGoogleBoundsFromPoints(pointsArray)
      } else {
        bounds.union(mapConverters.getGoogleBoundsFromPoints(pointsArray))
      }
    }

    return bounds;
  }

  removeAllOverlaysFromMap() {
    var self = this;
    Object.keys(this.data.filteredOverlayShapesOnTheMap).forEach(shapeId => {
      self.data.filteredOverlayShapesOnTheMap[shapeId].forEach(function(googleShape) {
        let pointsArray = googleShape.getPath();
        if (bounds === null) {
          bounds = mapConverters.getGoogleBoundsFromPoints(pointsArray)
        } else {
          bounds.union(mapConverters.getGoogleBoundsFromPoints(pointsArray))
        }
      });
    });
  }

  getLoadedMyMapOverlayShape(shapeId) {
    // Synchronous lookup for a shape that should already be loaded in memory
    for(let key in this.data.overlays) {
      const shape = this.data.overlays[key].Shapes.find(shape => shape.Id === shapeId.replace(/^'|'$/g, ''));
      if (shape) {
        return shape;
      }
    }
    return null;
  }

  convertShapeToGooglePolygon(shapeData) {
    // Helper method - Convert shape data to Google Maps Polygon for bounds calculation
    return this._buildGoogleShape(shapeData, {});
  }

  toggleFilteredOverlayShapesVisibility(visible) {
    Object.keys(this.data.filteredOverlayShapesOnTheMap).forEach(shapeId => {
      this.data.filteredOverlayShapesOnTheMap[shapeId].forEach(function(googleShape) {
        googleShape.setVisible(visible);
      });
    });
  }

  toggleUnfilteredOverlayShapesVisibility(visible) {
    Object.keys(this.data.overlaysOnTheMap).forEach(key => {
      this.data.overlaysOnTheMap[key].forEach(function(googleShape) {
        googleShape.setVisible(visible);
      });
    });
  }
}

const instance = new GlobalOverlayManager();
Object.freeze(instance)
export default instance;
